<template>
<div class="sale-status tw-flex tw-flex-col tw-items-center type-client">
    <title-section
    title="Estado de venta"
    subtitle="¿Quieres vender tu vivienda?"></title-section>

    <div class="mdc-chip-set mdc-chip-set--choice justify-center tw-mt-8 tw-flex tw-flex-col">
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('Mi vivienda ya está a la venta')}" @click="selectChip('Mi vivienda ya está a la venta')" role="row">
        <div class="mdc-chip__ripple"></div>
        <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
            <span class="tw-leading-8 tw">Mi vivienda ya está a la venta</span>
            </span>
        </span>
        <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
        </span>
        </div>
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('Quiero vender mi vivienda rápidamente')}" @click="selectChip('Quiero vender mi vivienda rápidamente')" role="row">
        <div class="mdc-chip__ripple"></div>
        <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
            <span class="tw-leading-8 tw">Quiero vender mi vivienda rápidamente</span>
            </span>
        </span>
        <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
        </span>
        </div>
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('Estoy pensando en poner mi vivienda a la venta próximamente')}" @click="selectChip('Estoy pensando en poner mi vivienda a la venta próximamente')" role="row">
        <div class="mdc-chip__ripple"></div>
        <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
            <span class="tw-leading-8 tw">Estoy pensando en poner mi vivienda a la venta próximamente</span>
            </span>
        </span>
        <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
        </span>
        </div>
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('No voy a vender mi vivienda en brev')}" @click="selectChip('No voy a vender mi vivienda en brev')" role="row">
        <div class="mdc-chip__ripple"></div>
        <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
            <span class="tw-leading-8 tw">No voy a vender mi vivienda en breve</span>
            </span>
        </span>
        <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
        </span>
        </div>
    </div>
</div>
</template>

<script>
import { initiateChips } from "../../utils";
import { mapMutations, mapGetters } from "vuex";
export default {
computed: {
    ...mapGetters({
        wizard: 'getWizard'
    })
},
methods: {
    ...mapMutations(["selectSaleState"]),
    selectChip(chip) {
    this.selectSaleState(chip);
    this.$router.push({ name: "Burdened" });
    },
    isSelected(chip){
        return chip === this.wizard.saleState;
    }
},
mounted() {
    initiateChips();
}
};
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
.sale-status {
    .mdc-chip {
        width: 100% !important;
        justify-content: flex-start !important;
        @media(max-width: $lg){
            height: auto !important;
            padding:2rem;
        }
    }
}
</style>
      